"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
require("core-js/modules/es.array.reverse.js");
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _Item = _interopRequireDefault(require("./Item"));
var _constants = require("../../../utils/constants");
var _selectors = require("../../../redux/selectors");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  ComponentTypes
} = _paulCorePackage.constants;
const List = _ref => {
  let {
    idList = [],
    showDefPipe = false
  } = _ref;
  const hasPwhC = (0, _reactRedux.useSelector)((0, _selectors.selectStructureShowModelByType)(_constants.TypesByDep.PwhC));
  if (!idList.length && !showDefPipe) return null;
  if (!idList.length) return /*#__PURE__*/_react.default.createElement(_Item.default, {
    equipmentId: null,
    connectWithNext: false,
    isDisabled: true,
    hideCirculation: !hasPwhC,
    position: [0, 0, 0]
  });
  return idList.reverse().map((id, i, map) => /*#__PURE__*/_react.default.createElement(_Item.default, {
    key: id,
    equipmentId: id,
    connectWithNext: i !== map.length - 1,
    position: [0, 0, i * (_constants.ModelWidth[ComponentTypes.PwhPipe] + _constants.spaseBetweenModels)]
  }));
};
exports.List = List;
List.propTypes = {
  idList: _propTypes.default.arrayOf(_propTypes.default.string),
  showDefPipe: _propTypes.default.bool
};